import React from 'react';
import cx from 'classnames';
import { Trans } from '@elevio/kb-kit/lib/components/trans';
import LoginLogout from './LoginLogout';
const CONTACT_US = 'https://www.chinohills.org/Directory.aspx';
const CITY_HOME = 'https://www.chinohills.org/';
function Footer({ className }) {
    return (<div className={cx('footer', className)} data-testid="footer">
      <div className="footer-wrapper">
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Comcate, Inc.
        </p>
        <nav className="footer-nav">
          <a className="footer-link" target="_blank" rel="noopener noreferrer" href={CONTACT_US}>
            <Trans>Contact Us</Trans>
          </a>
          <a className="footer-link" target="_blank" rel="noopener noreferrer" href={CITY_HOME}>
            <Trans>City of Chino Hills</Trans>
          </a>
          <LoginLogout className="footer-link"/>
        </nav>
      </div>
    </div>);
}
export default Footer;
